import React, { useEffect, useState } from "react";


const API_URL = `${process.env.REACT_APP_API_BASE_URL}/Shade`;

const Settings: React.FC = () => {

  return (
    <div className="container mt-2">
      <h4 className="mb-4 fw-bold"> Settings</h4>
    </div>
  );
};

export default Settings;
